import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Layout from './components/Layout';
import Login from './pages/Login';
import Signup from './pages/Signup';
import ProtectedRoute from './components/ProtectedRoute';
import AdminRoute from './components/AdminRoute';
import { AuthProvider } from './context/AuthContext';
import Logout from './pages/Logout';
import Dashboard from './pages/Dashboard';
import Home from './pages/Home';
import Contacts from './pages/Contacts';
import Reservations from './pages/Reservations';
import AdminDashboard from './pages/AdminDashboard';
import VerifyEmail from './pages/VerifyEmail';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import Servicies from './pages/Servicies';
import CookiePolicy from './pages/CookiePolicy';
import PrivacyPolicy from './pages/PrivacyPolicy';
import NotFound from './pages/NotFound';
import Thanks from './pages/Thanks';
import Book from './pages/Book';
import { BookingProvider } from './context/BookingContext';
import BookRecap from './pages/BookRecap';
import FAQ from './pages/FAQ';
import { HelmetProvider } from 'react-helmet-async';
import SEO from './components/SEO';

function App() {
  return (
    <HelmetProvider>
      <AuthProvider>
        <BookingProvider>
          <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
            <Layout>
              <Routes>
                <Route
                  path="/"
                  element={
                    <>
                      <SEO
                        title={'Home Page'}
                        description={
                          'Un servizio pensato per ogni esigenza. Affidabilità, flessibilità e professionalità sono al centro della nostra offerta. Scopri cosa rende NCC BRO DRIVER la scelta ideale per i tuoi spostamenti.'
                        }
                        canonical={'/'}
                        ogImage={'/img/donna-d-affari-che-sale-su-un-taxi-scaled.jpg'}
                      />
                      <Home />
                    </>
                  }
                />
                <Route path="/login" element={<Login />} />
                <Route path="/signup" element={<Signup />} />
                <Route path="/logout" element={<Logout />} />
                <Route
                  path="/contatti"
                  element={
                    <>
                      <SEO
                        title={'Contatti'}
                        description={
                          'Hai bisogno di un trasferimento? Inviaci la tua richiesta e ti ricontatteremo in breve tempo con tutti i dettagli.'
                        }
                        canonical={'/contatti'}
                        ogImage={
                          '/img/colleghi-che-lavorano-insieme-un-ufficio-del-call-center-con-il-caffe.jpg'
                        }
                      />
                      <Contacts />
                    </>
                  }
                />
                <Route path="/verify-email" element={<VerifyEmail />} />
                <Route path="/forgot-password" element={<ForgotPassword />} />
                <Route
                  path="/servizi"
                  element={
                    <>
                      <SEO
                        title={'Servizi'}
                        description={
                          'Trasferimenti da e per aeroporti. Trasferimenti aziendali e meeting. Viaggi su lunghe distanze. Matrimoni ed eventi speciali. Visite guidate in Franciacorta. Outlet Village'
                        }
                        canonical={'/servizi'}
                      />
                      <Servicies />
                    </>
                  }
                />
                <Route path="/cookie-policy" element={<CookiePolicy />} />
                <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                <Route path="/reset-password" element={<ResetPassword />} />
                <Route path="/thank-you" element={<Thanks />} />
                <Route path="/booking" element={<Book />} />
                <Route path="/faq" element={<FAQ />} />
                <Route
                  path="/booking/:uid"
                  element={
                    <AdminRoute>
                      <BookRecap />
                    </AdminRoute>
                  }
                />
                <Route
                  path="/admin"
                  element={
                    <AdminRoute>
                      <AdminDashboard />
                    </AdminRoute>
                  }
                />
                <Route
                  path="/dashboard"
                  element={
                    <ProtectedRoute>
                      <Dashboard />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/reservations"
                  element={
                    <ProtectedRoute>
                      <Reservations />
                    </ProtectedRoute>
                  }
                />
                <Route path="/404" element={<NotFound />} />
                <Route path="*" element={<Navigate to="/404" replace />} />
              </Routes>
            </Layout>
          </Router>
        </BookingProvider>
      </AuthProvider>
    </HelmetProvider>
  );
}

export default App;
